/** A readable message from a partner API error: the backend answers 400s field-keyed
 *  (`{code: ["..."]}`, `{email: ["..."]}`), 409s with `{detail}`. */
import { ConsoleApiError } from '@/api/client';

export function partnerErrorMessage(e: unknown, fallback = 'Save failed.'): string {
  if (!(e instanceof ConsoleApiError)) return fallback;
  if (e.body?.detail) return e.body.detail;
  const body = e.body as Record<string, unknown> | undefined;
  for (const value of Object.values(body ?? {})) {
    if (Array.isArray(value) && typeof value[0] === 'string') return value[0];
    if (typeof value === 'string') return value;
  }
  return e.message || fallback;
}
